export const NOTIFICATION_LIST_REQUEST = "NOTIFICATION_LIST_REQUEST";
export const NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_LIST_FAIL = "NOTIFICATION_LIST_FAIL";

export const NOTIFICATION_MARK_READ_REQUEST = "NOTIFICATION_MARK_READ_REQUEST";
export const NOTIFICATION_MARK_READ_SUCCESS = "NOTIFICATION_MARK_READ_SUCCESS";
export const NOTIFICATION_MARK_READ_FAIL = "NOTIFICATION_MARK_READ_FAIL";

export const NOTIFICATION_MARK_ALL_READ_REQUEST = "NOTIFICATION_MARK_ALL_READ_REQUEST";
export const NOTIFICATION_MARK_ALL_READ_SUCCESS = "NOTIFICATION_MARK_ALL_READ_SUCCESS";
export const NOTIFICATION_MARK_ALL_READ_FAIL = "NOTIFICATION_MARK_ALL_READ_FAIL";

export const NOTIFICATION_UNREAD_LIST_REQUEST = "NOTIFICATION_UNREAD_LIST_REQUEST";
export const NOTIFICATION_UNREAD_LIST_SUCCESS = "NOTIFICATION_UNREAD_LIST_SUCCESS";
export const NOTIFICATION_UNREAD_LIST_FAIL = "NOTIFICATION_UNREAD_LIST_FAIL";
